
import { HostClientType } from "@microsoft/teams-js";
import { mutatorAction } from "satcheljs";
import HostPlatformStore from "../store";

export default mutatorAction('SET_HOSTPLATFORM_IN_STORE', function setHostPlatformInStore(hostPlatform: HostClientType) {
    HostPlatformStore().hostPlatform = hostPlatform;
});
